import { Box, Typography } from '@mui/material';

import Input from '../../../form/Input';
import PessoaPerfisAcesso from './PessoaPerfisAcesso';
import Checkbox from '../../../form/Checkbox';

export default function PessoaTabUsuario({ module, pessoa, pessoaEmpresas }) {
    const { dados } = module.state;
    const { change } = module.actions;

    return (
        <Box sx={{ display: 'grid', gap: 1 }}>
            <Typography variant="h6">Configura usuário do sistema e sua permissões</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Input
                    text="Usuário"
                    name="pessoaUsuario.usuario"
                    title="descrição de acesso ao siostema"
                    inputWidth="200px"
                    handleOnChange={change}
                    value={dados.usuario || ''}
                />
                <Checkbox
                    title="Caso desmarcado o usuário não poderá acessar o sistema"
                    text="Ativo"
                    name="pessoaUsuario.ativo"
                    handleOnChange={change}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
                <Checkbox
                    title="Ativado para administradores do sistema"
                    text="Administrador"
                    name="pessoaUsuario.isAdmin"
                    handleOnChange={change}
                    value={dados.isAdmin}
                    disabled={localStorage.getItem('isAdmin') !== 'true'}
                    checked={!!dados.isAdmin}
                />
                <Input
                    text="Senha"
                    type="password"
                    title="Senha do usuário"
                    name="pessoaUsuario.senha"
                    inputWidth="180px"
                    handleOnChange={change}
                    value={dados.senha || ''}
                />
                <Input
                    text="Confirme a senha"
                    type="password"
                    name="pessoaUsuario.confirmeSenha"
                    inputWidth="180px"
                    placeholder="Conrfirme a senha"
                    title="confirmação de senha do usuário"
                    handleOnChange={change}
                    value={dados.confirmeSenha}
                />
            </Box>
            <Typography variant="h6">Administrativo</Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                <Checkbox
                    title="Permite o usuário alterar a data do plantão"
                    text="Data"
                    name="pessoaUsuario.plantaoAlteraData"
                    handleOnChange={change}
                    value={dados.plantaoAlteraData}
                    checked={!!dados.plantaoAlteraData}
                />
                <Checkbox
                    title="Permite o usuário concluir o plantão"
                    text="Conclui"
                    name="pessoaUsuario.plantaoPermiteConcluir"
                    handleOnChange={change}
                    value={dados.plantaoPermiteConcluir}
                    checked={!!dados.plantaoPermiteConcluir}
                />
                <Checkbox
                    title="Permite o usuário assinar o plantão"
                    text="Assina"
                    name="pessoaUsuario.plantaoAssinatura"
                    handleOnChange={change}
                    value={dados.plantaoAssinatura}
                    checked={!!dados.plantaoAssinatura}
                />
                <Checkbox
                    title="Restringe determinadas rotinas do sistema para o usuário, protegendo assim informações da folha de pagamento por exemplo"
                    text="Restrito"
                    name="pessoaUsuario.restrito"
                    handleOnChange={change}
                    value={dados.restrito}
                    checked={!!dados.restrito}
                />
            </Box>
            <PessoaPerfisAcesso
                pessoa={pessoa ?? module.state.pessoa}
                pessoaEmpresas={pessoaEmpresas ?? module.state.pessoaEmpresas}
                empresaIds={module.state.empresaIds}
                empresaIdAtual={module.state.empresaId}
            />
        </Box>
    );
}
